import { useCallback } from 'react';
import { useErrorDialog } from '@ianesthesie-kit/redux';
import { useGenerateFullReport } from '@/modules/surgicalEvent';
import { useCurrentPatientIdParam } from '@/hooks';
import type { InvertedDocumentMedium } from '@/modules/ui';

export const useCompleteReport = () => {
  const { showErrorDialog } = useErrorDialog();
  const patientId = useCurrentPatientIdParam();
  const [generatePdf, { isLoading }] = useGenerateFullReport({
    fixedCacheKey: `complete-report-gen-${patientId}`
  });

  const generate = useCallback(async (): Promise<
    InvertedDocumentMedium | undefined
  > => {
    if (!patientId) {
      return undefined;
    }
    try {
      const report = await generatePdf({ patientId }).unwrap();
      const medium = report.media?.[0];
      if (!medium) {
        return undefined;
      }
      return { ...medium, medicalDocument: report };
    } catch (error: any) {
      showErrorDialog(error);
      return undefined;
    }
  }, [generatePdf, patientId, showErrorDialog]);

  return { generate, isLoading, enabled: !!patientId };
};
